import { useEffect, useRef, useState } from "react";

const SPACES = [
  {
    title: "Khu vực thư giãn",
    description: "Không gian êm dịu với cây xanh và ánh sáng tự nhiên giúp bạn thả lỏng hoàn toàn.",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20relaxation%20lounge%20in%20a%20green%20wellness%20spa%20with%20soft%20armchairs%20warm%20wood%20floor%20and%20indoor%20plants%20natural%20sunlight%20streaming%20through%20large%20windows%20calm%20minimalist%20interior%20design&width=800&height=600&seq=about-space-1&orientation=landscape",
    icon: "ri-plant-line",
  },
  {
    title: "Cabin spa thông minh",
    description: "Công nghệ chăm sóc hiện đại, thiết kế tinh gọn mang lại hiệu quả tối ưu cho cơ thể.",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20high%20tech%20spa%20cabin%20pod%20with%20sleek%20curved%20design%20soft%20green%20ambient%20lighting%20clean%20white%20and%20wood%20interior%20futuristic%20wellness%20treatment%20room&width=800&height=600&seq=about-space-2&orientation=landscape",
    icon: "ri-cpu-line",
  },
  {
    title: "Khu vực tiếp đón",
    description: "Đội ngũ tận tâm luôn sẵn sàng đón tiếp và tư vấn lộ trình phù hợp nhất cho bạn.",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20reception%20area%20of%20a%20green%20wellness%20center%20with%20natural%20wood%20counter%20green%20plant%20wall%20soft%20warm%20lighting%20welcoming%20minimalist%20atmosphere&width=800&height=600&seq=about-space-3&orientation=landscape",
    icon: "ri-customer-service-2-line",
  },
];

export default function SpaceSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-secondary-100 text-secondary-800 text-xs md:text-sm font-label font-medium rounded-full mb-4">
            <i className="ri-building-2-line" />
            Không gian của chúng tôi
          </span>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Nơi bạn tìm lại sự cân bằng
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto font-body">
            Mỗi góc nhỏ tại Xanh Wellness đều được chăm chút để mang đến cảm giác thư thái ngay khi bước vào.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {SPACES.map((space, index) => (
            <div
              key={space.title}
              className={`group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-500 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: visible ? `${index * 120}ms` : "0ms" }}
            >
              <div className="relative h-52 md:h-60 overflow-hidden">
                <img
                  src={space.image}
                  alt={space.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600">
                  <i className={`${space.icon} text-base`} />
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-display text-base md:text-lg font-semibold text-foreground-950 mb-2">
                  {space.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed font-body">
                  {space.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}